import { colors } from 'ui/theme';
import { Link } from 'ui/links';
import {
  StyledCopyAssistDropdownFooter,
  StyledLoadingSection,
  StyledResetSection,
  StyledLegalSection,
  StyledAnimatedResetBtn,
  StyledGradientSpinner,
} from 'modules/ai/copyAssist/components/dropdown/styles';
import { AI_TERMS_OF_USE_URL } from 'modules/ai/constants';

interface CopyAssistDropdownFooterProps {
  // callback for when reset button is clicked
  onResetButtonClick: () => void;
  isLoading: boolean;
}

export const CopyAssistDropdownFooter = ({
  onResetButtonClick,
  isLoading,
}: CopyAssistDropdownFooterProps) => {
  return (
    <StyledCopyAssistDropdownFooter data-test="copy-assist-dropdown-footer">
      {isLoading ? (
        <StyledLoadingSection data-test="copy-assist-loading-footer-section">
          <StyledGradientSpinner />
          <span>Iterating on your perfect message</span>
        </StyledLoadingSection>
      ) : (
        <>
          <StyledResetSection data-test="copy-assist-reset-section" onClick={onResetButtonClick}>
            <StyledAnimatedResetBtn color={colors.purple100} />
            {'Try Again'}
          </StyledResetSection>
          <StyledLegalSection>
            <Link
              size="caption"
              variant="monochrome"
              data-test="copy-assist-legal-terms"
              href={AI_TERMS_OF_USE_URL}
              rel="noreferrer noopener"
              target="_blank"
            >
              Terms
            </Link>
            {'apply when using Iterable AI'}
          </StyledLegalSection>
        </>
      )}
    </StyledCopyAssistDropdownFooter>
  );
};
